<div class="">
    <div class="bg-white">
        <div class="row align-items-end pb-3 h-120">
            <div class="col-1"></div>
            <div class="col-7">
                <span class="header-content">
                    Update {{displayCurrentType}}
                </span>
            </div>
        </div>
    </div>
    <div class="bg-grey" style="height: 100vh;">
        <div class="row pt-5">
            <div class="col-1"></div>
            <div class="col-7" id="adiminprofile">
                <div class="card border-0" *ngIf="currentType === 'email'">
                    <mat-form-field appearance="outline" class="w-100 top-left-border top-right-border">
                        <mat-label>Email</mat-label>
                        <input matInput [(ngModel)]="email">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>New Email</mat-label>
                        <input matInput [(ngModel)]="newEmail">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Confirm New Email</mat-label>
                        <input matInput [(ngModel)]="confirmEmail">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100 bottom-left-border bottom-right-border">
                        <mat-label>Password</mat-label>
                        <input matInput [(ngModel)]="password">
                        <mat-icon matSuffix class="primary-eye" (click)="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                </div>
                <div class="card border-0" *ngIf="currentType === 'password'">
                    <mat-form-field appearance="outline" class="w-100 top-left-border top-right-border">
                        <mat-label>Current Password</mat-label>
                        <input matInput [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password">
                        <mat-icon matSuffix class="primary-eye"(click)="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>New Password</mat-label>
                        <input matInput [type]="showNewPassword ? 'text' : 'password'"[(ngModel)]="newPassword">
                        <mat-icon matSuffix class="primary-eye" (click)="showNewPassword = !showNewPassword">{{showNewPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100 bottom-left-border bottom-right-border">
                        <mat-label>Confirm New Password</mat-label>
                        <input matInput [type]="showConfirmPassword ? 'text' : 'password'"[(ngModel)]="confirmPassword">
                        <mat-icon matSuffix class="primary-eye" (click)="showConfirmPassword = !showConfirmPassword">{{showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                </div>
                <div class="card border-0" *ngIf="currentType === 'phone_number'">
                    <mat-form-field appearance="outline" class="w-100 top-left-border top-right-border">
                        <mat-label>Current Number</mat-label>
                        <input matInput [(ngModel)]="phoneNumber">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>New Phone Number</mat-label>
                        <input matInput [(ngModel)]="newPhoneNumber">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100 bottom-left-border bottom-right-border">
                        <mat-label>Password</mat-label>
                        <input matInput [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password">
                        <mat-icon matSuffix class="primary-eye" (click)="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                </div>
            </div>
            <div class="col p-0">
                <div class="cursor font-13" style="color: #3F3C3C;position: absolute; bottom: 30px;" [ngStyle]="{ 'top': currentType === 'password'?'30px': '', 
                            'bottom':currentType !== 'password'? '30px' : ''}" (click)="navToForgotPassword()">Forgot Password?</div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-1"></div>
            <div class="col-7 d-flex justify-content-end">
                <div class="text-center cursor d-flex justify-content-center align-items-center" style="color: var(--primary-btn-color);width: 35%;" (click)="location.back()">Cancel</div>
                <button class="btn d-flex justify-content-center align-items-center ml-3 w-50 primary-bg text-white" style="height: 50px" [disabled]="!isValidForm()" (click)="updateAdmin()">Update</button>
            </div>
        </div>
    </div>
</div>